export default {
  letsPlayBrand: "VAMOS A JUGAR",
  "courtSize": {"single": "Individual", "double": "Doble"},
  "unfinishedColumn": "Parcial",
  "rejectedSave": "Tu club no pudo aceptar estos cambios. Tus acciones locales se conservan. Revisa el último marcador o descarga tus acciones antes de descartarlas.",
  "unverifiedSave": "No pudimos verificar el guardado. Tus acciones locales se conservan. Revisa el último marcador o descarga tus acciones antes de descartarlas.",

  "finishQuestion": "¿Finalizar la sesión?",
  "saveFinish": "Guardar y finalizar",
  "unfinishedOutcome": "Sesión sin terminar",
  "tiedOutcome": "Marcador empatado",
  "finishedOutcome": "Sesión finalizada",
  "savingResult": "Guardado en este dispositivo · Guardando en tu club…",
  "offlineResult": "Guardado en este dispositivo · Se sincronizará al conectar",
  "syncedResult": "Guardado en tu club",
  "momentWaiting": "Tu momento se abrirá al terminar de guardar…",
  "saveFailed": "No se pudo sincronizar. El marcador sigue en este dispositivo.",

  "deleteChanged": "La sesión cambió antes de eliminarla. Reanúdala para revisar los últimos resultados y vuelve a intentar eliminarla.",
  "moreActions": "Más",
  "deleteSession": "Eliminar sesión",
  "deleteNote": "¿Eliminar esta sesión de Continuar jugando? Se conservan los resultados y el historial. Las reservas de pista no cambian.",
  "deletePending": "Esta sesión tiene resultados sin sincronizar o un borrador local. Reanúdala para sincronizar o revisar y descartar los cambios antes de eliminarla.",
  "deleting": "Eliminando…",
  "live": "En directo",
  "completedSet": "Set completado",
  "completedGame": "Juego completado",
  "sports": "Deportes",
  "format": "Formato",
  "pointAction": "Punto",
  "serviceSetup": "Configurar servicio",
  "finalScores": "Resultados finales",
  "scoringMode": "Modo de puntuación",
  "enterScores": "Introduce tus resultados",
  "reviewSave": "Revisar y guardar",
  "applyContinue": "Aplicar resultados y continuar en directo",
  "discardContinue": "Descartar cambios y continuar en directo",
  "changeService": "Cambiar servidor / servicio",
  "choose": "Seleccionar…",
  "rallyWon": "Intercambio ganado",
  "discardChanges": "Descartar cambios",
  "error_draft_unreadable": "No se pudo leer el borrador guardado. Conserva los datos del dispositivo y contacta con soporte antes de sustituirlo.",
  "error_draft_action_required": "Revisa o descarta los cambios de tarjeta, o sigue editando, antes de puntuar de otra forma.",
  "error_draft_consent_required": "Revisa el resultado de sustitución y confirma para finalizar.",
  "error_draft_revision_changed": "Compara tus datos con el último resultado guardado y confirma la comparación.",
  "error_point_mode_changed": "Confirma los nuevos controles de puntos antes de revisar este resultado.",
  "error_point_combination_invalid": "La ventaja debe ir acompañada de 40. Para iguales, elige 40 para ambos jugadores.",
  "keepDraftAndLeave": "Conservar cambios y salir",
  "discardAndLeave": "Descartar cambios y salir",
  "keepEditing": "Seguir editando",
  "draftLeaveNote": "Los resultados introducidos no se han aplicado. Consérvalos para volver después, descártalos o sigue editando.",
  "unappliedChanges": "Cambios de resultado sin aplicar",
  "reviewAndFinish": "Revisar resultado y finalizar sesión",
  "cardDraftPreserved": "Cambios de tarjeta sin aplicar",
  "draftPending": "Estos cambios revisados están en cola. No se pueden aplicar dos veces.",
  "draftStorageError": "Tus cambios siguen aquí, pero no se pudieron guardar en este dispositivo. Mantén esta pantalla abierta y vuelve a intentarlo.",
  "directHistoryDetails": "Esto sustituye el progreso dependiente, incluido el juego posterior. Todas las acciones anteriores permanecen en el historial.",
  "replacementDetails": "¿Qué cambia?",
  "reconcileDraft": "He comparado mis datos con el último resultado guardado",
  "draftRevisionChanged": "El resultado guardado cambió mientras editabas. Compáralo con tus datos antes de sustituirlo.",
  "useOrdinaryPoints": "Usar puntos de juego · borrar puntos actuales",
  "useTieBreakPoints": "Usar puntos de desempate · borrar puntos actuales",
  "pointModeChanged": "El último set ha cambiado de modo. Elige los controles de puntos; se borrarán los puntos actuales.",
  "advantage": "Ventaja",
  "loveZero": "Cero / 0",
  "serviceUnknown": "Saque sin registrar",
  "interpreting": "Interpretando…",
  "reopenCorrection": "Esta corrección vuelve a abrir la sesión. Revisa el resultado y finaliza de nuevo la sesión para guardarla.",
  "tieBreakFirstServer": "¿Quién sacó primero en este desempate?",
  "preparingMatch": "Preparando tu sesión",
  "preparingDetail": "Preparando pistas y jugadores",
  "restoringMatch": "Recuperando tu sesión",
  "restoringDetail": "Preparando tu tarjeta",
  "setupProgress": "Preparación de la sesión",
  "member": "Socio",
  "session_saved": "Sesión guardada",
  "sessionSaved": "Sesión guardada",
  "sessionPending": "Sesión pendiente de sincronizar",
  "playEnded": "Juego finalizado. Sin ganador general.",
  "finishSession": "Revisar y guardar",
  "set": "Set",
  "game": "Juego",
  "points": "Puntos",
  "unfinishedSegment": "En curso · sin terminar",
  "segmentCompleted": "Completado",
  "addSet": "Añadir otro set",
  "addGame": "Añadir otro juego",
  "currentPointsOptional": "Puntos actuales (opcional)",
  "directHistoryAck": "Sustituir el resultado registrado",
  "directEntryReason": "Entrada de tarjeta revisada",
  "reviewScore": "Revisar y guardar",
  "receivingFirst": "¿Quién recibe primero en el otro equipo?",
  "rightCourt": "Jugador a la derecha · equipo",
  "startLive": "Continuar puntuación en vivo",
  "operation_direct_score": "Marcador introducido",
  "operation_configure_service": "Saque confirmado",
  "operation_finish_session": "Sesión finalizada",
  "error_unfinished_segment_must_be_last": "Solo el último segmento puede quedar sin terminar. Complétalo antes de añadir otro.",
  "error_mark_segment_completed": "Este resultado completa el segmento. Márcalo como completado o corrige el resultado.",
  "correctLastRally": "Corregir el último intercambio",
  "operation_replace_last_rally": "Último intercambio corregido",
  "conflictStatus": "Requiere revisión",
  "storageStatus": "Requiere revisión",
  "pendingOnline": "Guardando",
  "historyTitle": "Tu Let’s Play",
  "historyIntro": "Tus rondas, partidos y recuerdos compartidos.",
  "all": "Todos",
  "filterHistory": "Filtrar historial",
  "historyLoad": "Cargando tu historial",
  "historyEmptyTitle": "Tu historial empieza aquí",
  "historyEmpty": "Las actividades completadas aparecerán aquí.",
  "more": "Cargar más",
  "manageMoment": "Gestionar recuerdo",
  "photoUnavailable": "Foto no disponible",
  "moment_loadError": "No pudimos abrir el recuerdo de esta actividad.",
  "moment_imageError": "Elige una imagen JPEG, PNG o WebP de hasta 15 MB.",
  "moment_discard": "¿Descartar esta foto?",
  "moment_offline": "Sin conexión. La actividad está guardada; puedes añadir el recuerdo después desde el historial.",
  "moment_conflict": "El recuerdo cambió en otro dispositivo. Recarga antes de reintentar.",
  "moment_saveError": "No se guardó la foto. Consérvala aquí y reinténtalo.",
  "moment_captionError": "No se pudo guardar el pie de foto.",
  "moment_removeConfirm": "¿Eliminar este recuerdo? La actividad completada no cambiará.",
  "moment_removeError": "No se pudo eliminar el recuerdo. Recarga y reinténtalo.",
  "moment_opening": "Abriendo tu recuerdo",
  "moment_access": "Comprobando acceso a la actividad",
  "moment_unavailable": "Recuerdo no disponible",
  "moment_label": "RECUERDO DE LA ACTIVIDAD",
  "moment_from": "Un recuerdo de esta actividad",
  "moment_none": "No se capturó ningún recuerdo",
  "moment_alt": "Recuerdo de la actividad",
  "moment_your": "TU RECUERDO",
  "moment_activityComplete": "ACTIVIDAD COMPLETADA",
  "moment_remember": "Para recordar",
  "moment_capture": "¿Capturamos el momento?",
  "moment_intro": "Los grandes partidos merecen un recuerdo.",
  "moment_editCaption": "Editar pie de foto",
  "moment_saveCaption": "Guardar pie de foto",
  "moment_remove": "Eliminar recuerdo",
  "moment_take": "Hacer foto",
  "moment_replace": "Sustituir foto",
  "moment_choose": "Elegir foto",
  "moment_later": "Ahora no",
  "moment_keep": "¿Guardamos esta?",
  "moment_preview": "Vista previa de la foto elegida",
  "moment_caption": "Añade un pie de foto (opcional)",
  "moment_captionExample": "Partido de verano con Chris",
  "moment_preparing": "Preparando y guardando…",
  "moment_save": "Guardar recuerdo",
  "moment_another": "Elegir otra",
  "error_invalid_segment_score": "Introduce un resultado válido de set/juego completo o marca la última fila sin terminar. Revisa las filas.",
  "error_invalid_point_score": "Usa 0, 15, 30, 40 o ventaja. Un juego terminado necesita un resumen.",
  "error_invalid_game_score": "Introduce un set sin terminar hasta 6–6, o registra un set completo.",
  "error_invalid_correction": "Introduce ambos resultados y elige el sacador y el cuadro de saque.",
  "error_service_information_required": "Elige expresamente el siguiente sacador y el cuadro de saque.",
  "error_invalid_service_box": "El cuadro de saque no coincide con el marcador y el sacador. Comprueba su posición.",
  "error_invalid_service_order": "Comprueba el orden de saque. Los equipos deben alternarse en tenis y pádel.",
  "error_server_number_required": "Elige sacador 1 o 2 en dobles, o sacador 1 en individual.",
  "error_court_positions_required": "Confirma el jugador de cada equipo en el cuadro derecho antes de aplicar.",
  "error_invalid_court_positions": "El sacador no está en el cuadro elegido. Comprueba las posiciones.",
  "error_terminal_score_requires_segment": "Este resultado termina un juego o set. Usa un resumen de segmento completo.",
  "error_summary_would_rewrite_games": "El resultado final no puede borrar juegos registrados. Corrige primero los juegos actuales o revisa los segmentos anteriores.",
  "error_dependent_history_requires_resolution": "Confirma que se descartarán los segmentos posteriores y el progreso actual.",
  "error_queue_capacity_reached": "La cola del dispositivo está llena. Conecta para guardar antes de registrar más acciones.",
  "error_court_not_available_for_sport": "Esta pista ya no está disponible para este deporte. Elige otra.",
  "error_format_not_supported_by_court": "Elige un formato compatible con esta pista o selecciona otra.",
  "error_duplicate_participant": "Cada jugador debe aparecer una sola vez. Comprueba los equipos y los nombres de invitados.",
  "error_reason_required": "Introduce un motivo para que la corrección quede clara en el historial.",
  "tieBreak": "Desempate",
  "currentGames": "Juegos actuales (reinicia los puntos actuales)",
  "operation_correct_games": "Resumen de juegos actuales",
  "court": "Pista",
  "match": "Partido",
  "players": "Jugadores",
  "review": "Revisar",
  "where": "¿Dónde jugamos?",
  "how": "¿Cómo jugamos?",
  "who": "¿Quién juega?",
  "ready": "¿Todo listo?",
  "back": "Volver",
  "next": "Continuar",
  "retry": "Reintentar",
  "loading": "Cargando el partido…",
  "error": "No pudimos completar la solicitud. Comprueba la conexión y reinténtalo.",
  "noCourts": "No hay pistas adecuadas configuradas. Contacta con el club para configurar una pista.",
  "noReservation": "Crear un marcador no reserva una pista ni carga tu cuenta.",
  "indoor": "Interior",
  "outdoor": "Exterior",
  "singles": "Individual",
  "doubles": "Dobles",
  "adjust": "Ajustar puntuación",
  "start": "Empezar partido",
  "starting": "Iniciando…",
  "edit": "Editar",
  "resumeMatches": "Continuar jugando",
  "recent": "Jugadores recientes",
  "search": "Buscar un socio",
  "noResults": "No se encontraron socios",
  "guest": "Nombre del invitado",
  "addGuest": "Añadir invitado",
  "remove": "Quitar",
  "move": "Cambiar de equipo",
  "team": "Equipo",
  "youScorer": "Tú registras el marcador. Los demás participantes pueden ver el partido.",
  "server": "Sacador",
  "firstServer": "¿Quién saca primero?",
  "order": "Orden de saque",
  "initialBox": "Cuadro de saque inicial",
  "left": "Izquierda",
  "right": "Derecha",
  "requiredPlayers": "Añade los jugadores necesarios y asigna equipos iguales.",
  "saved": "Guardado",
  "saving": "Guardando",
  "pending": "Sin conexión",
  "conflict": "El partido cambió en otro dispositivo. Tus acciones pendientes se conservan.",
  "export": "Descargar acciones pendientes",
  "useServer": "Conservar marcador del servidor y descartar acciones pendientes",
  "discardConfirm": "He revisado el marcador del servidor y quiero descartar estas acciones pendientes.",
  "storageError": "El almacenamiento no está disponible. Mantén esta pantalla abierta y conecta para guardar. Descarga las acciones antes de salir.",
  "card": "Resultados finales",
  "rally": "Intercambio ganado",
  "point": "Punto ganado",
  "undo": "Deshacer",
  "voice": "Voz",
  "pause": "Pausar",
  "resume": "Reanudar",
  "paused": "Partido en pausa",
  "landscape": "Horizontal",
  "portrait": "Vertical",
  "rotate": "Gira el dispositivo para ampliar el marcador. Puede que debas desactivar el bloqueo de orientación.",
  "swap": "Intercambiar lados de pantalla",
  "sets": "Sets",
  "games": "Juegos",
  "serving": "Al saque",
  "boxRequired": "Elige el cuadro de saque antes del siguiente intercambio.",
  "correct": "Corregir / entrada rápida",
  "preview": "Revisar marcador",
  "apply": "Confirmar cambio",
  "cancel": "Cancelar",
  "before": "Antes",
  "after": "Después",
  "reason": "Motivo de la corrección",
  "current": "Puntos actuales",
  "awardGame": "Registrar juego actual (resumen)",
  "summary": "Registrar set/juego terminado",
  "historical": "Corregir un segmento anterior",
  "summaryNote": "La entrada resumida registra el resultado sin inventar intercambios. No hay estadísticas por punto para segmentos resumidos.",
  "discardFollowing": "Descartar los segmentos posteriores y el progreso actual tras este segmento",
  "segment": "Segmento",
  "history": "Acciones registradas",
  "summaryOnly": "Resumen",
  "rallyHistory": "Intercambio",
  "confirmResult": "Confirmar resultado final",
  "resultReady": "Hay ganador: ¿confirmamos?",
  "completed": "Partido terminado",
  "retired": "Retirada",
  "abandoned": "Abandonado",
  "unfinished": "Sin terminar",
  "in_progress": "En juego",
  "awaiting_confirmation": "Resultado pendiente de confirmar",
  "winner": "Ganador",
  "endEarly": "Finalizar antes de tiempo",
  "retire": "Retirarse",
  "abandon": "Abandonar",
  "finishUnfinished": "Guardar sin terminar",
  "earlyNote": "Se conserva el marcador sin declarar una victoria completa.",
  "scorecard": "Ver tarjeta",
  "done": "Volver a Let’s Play",
  "moment": "Añadir un recuerdo",
  "share": "Compartir resultado",
  "shareNote": "Comparte solo el deporte y el resultado. Se excluyen nombres, invitados y enlaces multimedia privados.",
  "listen": "Grabar resultado",
  "stop": "Detener grabación",
  "transcript": "Transcripción original",
  "interpret": "Interpretar resultado",
  "voiceReview": "Revisar marcador por voz",
  "voiceFailure": "La voz no está disponible. Puedes seguir manualmente o escribir la transcripción abajo.",
  "clarify": "Se necesita más información",
  "repair": "Corrección de transcripción propuesta",
  "ackRepair": "Acepto esta corrección de transcripción",
  "staleVoice": "Cambió el partido o la pantalla. Vuelve a interpretar antes de aplicar.",
  "deuce": "Iguales",
  "gamePoint": "Punto de juego",
  "matchPoint": "Punto de partido",
  "readOnly": "Puedes ver este partido. Solo su creador puede registrar el marcador.",
  "source": "Fuente de las reglas",
  "unknown": "Elige expresamente",
  "serverNumber": "Número de sacador",
  "positions": "Jugador en el cuadro derecho",
  "savedMatches": "Tus partidos",
  "noMatches": "Tus partidos aparecerán aquí.",
  "tennis": "Tenis",
  "padel": "Pádel",
  "pickleball": "Pickleball",
  "squash": "Squash",
  "tennis_one_set": "Un set · ventaja · desempate en 6–6",
  "tennis_best_of_three": "Al mejor de 3 sets · ventaja · desempate en 6–6",
  "padel_advantage": "Al mejor de 3 sets · ventaja (opción 1 FIP)",
  "pickleball_one_game": "Un juego a 11 · solo puntúa quien saca · diferencia de 2",
  "pickleball_best_of_three": "Al mejor de 3 a 11 · solo puntúa quien saca · diferencia de 2",
  "squash_best_of_three": "Al mejor de 3 a 11 · punto por intercambio · diferencia de 2",
  "squash_best_of_five": "Al mejor de 5 a 11 · punto por intercambio · diferencia de 2",
  "operation_rally": "Intercambio ganado",
  "operation_undo": "Deshacer",
  "operation_correct_current": "Corregir marcador actual",
  "operation_award_game": "Resumen de juego",
  "operation_summary_segment": "Resumen de segmento",
  "operation_replace_segment": "Corrección histórica; progreso posterior descartado",
  "operation_pause": "En pausa",
  "operation_resume": "Reanudado",
  "operation_confirm_result": "Resultado confirmado",
  "operation_service_box": "Cuadro de saque seleccionado",
  "operation_retire": "Retirada",
  "operation_abandon": "Abandonado",
  "operation_unfinished": "Guardado sin terminar",
  "moreOptions": "Más opciones",
  "backToScores": "Volver al marcador",
  "pointsForUnfinished": "Anota puntos actuales solo para un set sin terminar.",
  "error_completed_segment_has_points": "Quedan puntos de la puntuación en directo. Consérvalos en un nuevo set sin terminar o bórralos antes de guardar los sets completos.",
  "clearStalePoints": "Borrar puntos actuales",
  "retainUnfinishedPoints": "Conservar puntos en un set sin terminar",
  "resultHeading": "Para el recuerdo.",
  "sessionWinner": "Resultado de la sesión",
  "playEndedEarly": "El juego terminó antes de tiempo",
  "runnerUp": "Rival",
  "continue": "Continuar",
  "backToResult": "Volver al resultado",
  "completionAttention": "Requiere atención. Tus resultados pendientes se conservan.",
  "savedOnDevice": "Guardado en este dispositivo · pendiente de sincronizar",
  "serverConfirmed": "Confirmado por el servidor",
  "proposedScore": "Resultado final",
  "finishNote": "Se guardarán los resultados y finalizará el juego.",
  "replaceAndFinish": "Reemplazar resultados y finalizar",
  "saveAndFinish": "Guardar y finalizar",
  "replaceAndContinue": "Reemplazar resultados y continuar",
  "levelOnSets": "Empate en sets",
  "levelOnGames": "Empate en juegos",
  "reviewChanged": "Los resultados han cambiado. Cancela esta revisión, compara el marcador actual y vuelve a revisarlo.",
  "preparingReview": "Preparando revisión…",
  "reviewPreparationError": "No se pudo preparar esta revisión de voz. Cancela y vuelve a revisar; tus resultados se conservan."
}
